import React, { useState } from "react";
import {
  Globe,
  Smartphone,
  Monitor,
  Server,
  Palette,
  Code,
  ArrowRight,
  CheckCircle,
} from "lucide-react";
import "./Services.css";
import { useNavigate } from "react-router-dom";

// Helper function to create the Google Calendar URL
const createGoogleMeetLink = (serviceTitle) => {
  const title = encodeURIComponent(`30 Min Free Demo: ${serviceTitle}`);

  // Details will now guide the user and confirm the Meet link
  const details = encodeURIComponent(
    `Free 30-minute consultation for a ${serviceTitle} service. 
    
    A Google Meet link will be automatically generated by Google Calendar. 
    Please select a time slot and save the event to notify me of your booking.`
  );

  // 'add' takes a comma-separated list of guest emails.
  const guestEmail = "mnoumankhalid195@gmail.com";

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&details=${details}&add=${guestEmail}&tmeid=0&sf=true&output=xml`;
};

const Services = () => {
  const [activeService, setActiveService] = useState(0);
  const navigate = useNavigate();

  const services = [
    {
      icon: <Globe size={32} />,
      title: "Web Development",
      description: "Full-stack web applications with modern technologies",
      features: [
        "Responsive Design",
        "SEO Optimization",
        "Performance Optimization",
        "Modern UI/UX",
        "API Integration",
      ],
      technologies: ["React.js", "Node.js", "MongoDB", "Express.js"],
      color: "#00d4ff",
      gradient: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)",
    },
    {
      icon: <Smartphone size={32} />,
      title: "Mobile App Development",
      description: "Robust and scalable mobile application development",
      features: ["Native Performance", "Push Notifications", "Offline Support"],
      technologies: ["React Native", "Expo", "Firebase", "Redux"],
      color: "#ff0080",
      gradient: "linear-gradient(135deg, #ff0080 0%, #cc0066 100%)",
    },
    {
      icon: <Monitor size={32} />,
      title: "Desktop Applications",
      description: "desktop applications  with seamlesss performance .",
      features: ["Cross-Platform", "Auto Updates", "File System Access"],
      technologies: ["Electron.js", "Node.js", "React", "SQLite"],
      color: "#4050ff",
      gradient: "linear-gradient(135deg, #4050ff 0%, #3040cc 100%)",
    },
    {
      icon: <Server size={32} />,
      title: "Backend Development",
      description: "Scalable server-side applications and APIs",
      features: [
        "RESTful APIs",
        "Database Design",
        "Authentication & Security",
        "Real-time Features",
      ],
      technologies: ["Node.js", "Express.js", "MongoDB", "Socket.IO"],
      color: "#00ff88",
      gradient: "linear-gradient(135deg, #00ff88 0%, #00cc66 100%)",
    },
    {
      icon: <Palette size={32} />,
      title: "UI/UX Design",
      description: "User-centered design with modern aesthetics",
      features: [
        "User Research",
        "Wireframing",
        "Prototyping",
        "Design Systems",
        "Accessibility",
      ],
      technologies: ["Figma", "Tailwind CSS", "Material-UI"],
      color: "#ff6b35",
      gradient: "linear-gradient(135deg, #ff6b35 0%, #cc5529 100%)",
    },
    {
      icon: <Code size={32} />,
      title: "Custom Solutions",
      description: "Tailored software solutions for unique business needs",
      features: [
        "Business Analysis",
        "Custom Architecture",
        "Integration Services",
        "Maintenance & Support",
        "Performance Monitoring",
      ],
      technologies: ["React.js", "Node.js", "Python"],
      color: "#9d4edd",
      gradient: "linear-gradient(135deg, #9d4edd 0%, #7b2cbf 100%)",
    },
  ];

  // Handler for the "Get Free Demo" button
  const handleScheduleMeet = (serviceTitle) => {
    const calendarUrl = createGoogleMeetLink(serviceTitle);
    // Opens the Google Calendar event creation page in a new tab
    window.open(calendarUrl, "_blank");
  };

  return (
    <section className="services-section">
      <div className="container">
        <div className="services-header">
          <h2 className="services-title">Services</h2>
          <p className="services-subtitle">
            Comprehensive solutions for your digital needs
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-card ${
                activeService === index ? "active" : ""
              }`}
              onMouseEnter={() => setActiveService(index)}
              style={{
                "--service-color": service.color,
                "--delay": `${index * 100}ms`,
              }}
            >
              <div className="service-card-inner">
                <div className="service-header">
                  <div
                    className="service-icon"
                    style={{ background: service.gradient }}
                  >
                    {service.icon}
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                </div>

                <p className="service-description">{service.description}</p>

                <div className="service-features">
                  <h4 className="features-title">Key Features:</h4>
                  <ul className="features-list">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="feature-item">
                        <CheckCircle size={16} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="service-technologies">
                  <h4 className="tech-title">Technologies:</h4>
                  <div className="tech-badges">
                    {service.technologies.map((tech, idx) => (
                      <span
                        key={idx}
                        className="tech-badge"
                        style={{ borderColor: service.color }}
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="service-cta">
                  <button
                    className="service-btn"
                    style={{ background: service.gradient }}
                    // 👇 ADDED onClick HANDLER HERE
                    onClick={() => handleScheduleMeet(service.title)}
                  >
                    <span>Get Free Demo</span>
                    <ArrowRight size={16} />
                  </button>
                </div>
              </div>

              <div
                className="service-overlay"
                style={{ background: service.gradient }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
